import styled from "styled-components";

export const themes = {
  grey: { background: "#DEDEDE", color: "black" },
  dark: { background: "#025669", color: "white" },
  light: { background: "#ccdde1", color: "black" },
  green: { background: "#e7f5d6", color: "black" },
  red: { background: "#FBDADE", color: "black" },
};

export const Value = styled.div`
  font-family: Inter;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.12px;
  text-align: left;
`;

export const Left = styled.span`
  border-radius: 6px 0 0 6px;
  flex-basis: ${(props) => props.width}%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 2px;
  text-align: center;
`;

export const Mid = styled.span`
  flex-basis: ${(props) => props.width}%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 2px;
  margin-right: 2px;
  text-align: center;
`;

export const Right = styled.span`
  border-radius: 0 6px 6px 0;
  flex-basis: ${(props) => props.width}%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 2px;
  text-align: center;
`;

export const Full = styled.span`
  border-radius: 6px;
  flex-basis: 100%
  align-items: center;
  justify-content: center;
  display: flex;
  text-align: center;
`;

export const Bar = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  margin-bottom: 10px;
  padding: 6px;
  border: 2px solid gray;
  border-radius: 12px;
`;

export const Horizontal = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 10px;
  padding: 16px;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  background: #fdfdfd;
`;

export const Caption = styled.small`
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.12px;
  text-align: left;
`;

export const Margined = styled.div`
  margin-bottom: 10px;
`;
